// eslint-disable-next-line import/prefer-default-export
export const COMMUNITYUSER_INVITATION_SELECTOR_KEY = 'chats/invitations';
